import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const MainClientes = WithErrorBoundary(
  'Clientes',
  'Error en modulo de clientes',
  React.lazy(() => import('./MainClientes')),
)

export default {
  path: '/clientes',
  name: 'Clientes',
  childRoutes: [
    { path: '', name: 'Main clientes', component: MainClientes, isIndex: true },
    { path: 'crear', name: 'Clientes crear', component: MainClientes },
    { path: 'editar/:id', name: 'Clientes crear', component: MainClientes },
  ],
};
